import { GetServerSideProps } from 'next';
import {
  Cookies,
  MenuResponse,
  BaseResponseData,
  CustomerProfile,
  CmsReportReasonResponse,
  CustomerGearResponse,
  GearFilters,
} from 'types';
import { getMenuData, getCustomerProfile, getReportReasons, getCustomerGearList, getCustomerGearFilters } from 'api';
import { getCommonOgData, getPageDescription } from 'utils/seoFormatters';
import { getCanonicalUrlFromContext } from 'utils/formatters';
import { LISTING_GEAR_LIMIT } from 'containers/UserProfile/Tabs/ListingsTab';
import { UserProfilePage } from 'containers/UserProfile';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const cookies: Cookies = {
    parsed: context.req.cookies as Record<string, string>,
  };
  const {
    query: { username, force, tab=null },
  } = context;

  const menuDataRequest: Promise<MenuResponse> = getMenuData(!!force);
  const profileRequest: Promise<BaseResponseData<CustomerProfile>> = getCustomerProfile(username as string, cookies);
  const reportReasonsRequest: Promise<CmsReportReasonResponse> = getReportReasons('user', cookies);
  const listingDataRequest: Promise<CustomerGearResponse> = getCustomerGearList(String(username), {
    limit: LISTING_GEAR_LIMIT,
    status: 'all',
  });
  const filtersRequest: Promise<GearFilters> = getCustomerGearFilters(username as string, { status: 'all' });


  const [menuData, profile, reportReasons, listingData, filters] = await Promise.all([
    menuDataRequest,
    profileRequest,
    reportReasonsRequest,
    listingDataRequest,
    filtersRequest,
  ]);

  return {
    props: {
      menuData,
      username,
      tab,
      profile: profile.ok ? profile.data : null,
      reportReasons: reportReasons.ok ? reportReasons.data : [],
      listingData,
      filters,
      ogData: getCommonOgData({
        url: getCanonicalUrlFromContext(context),
        type: 'profile',
        title: `${profile.data?.username} | SENDY`,
        description: getPageDescription('user', { username: profile.data?.username }),
        banner: profile.data?.photo,
      }),
    },
  };
};

export default UserProfilePage;
